import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import cn from '../../../../lib/bem';
import ico_loading from './../../../../assets/icons/ico_loading.gif';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ButtonComponent from '../../../../components/button/button_component';
import { postEnviarCorreo, postEnviarSMS, postVerificarCodigo } from '../../../../redux/reducers/verifyCodeSlice';
import { postRegistrarEndosoPoliza} from '../../../../redux/reducers/endosoPolizaSlice';
import InputVerificationComponent from '../../../../components/inputVerification/inputVerification_component';
import NotificationComponent from '../../../../components/notification/notification_component';
import { CONTENT_PAG, LAYOUT_PAG } from '../../constants/content_pag';

import './verificacionCodigo.scss';

const VerificacionCodigo = ({mostrarFormularioEdicion, descripcionVerificacion, mostrarPolizaMensaje }) => {
    
    const classes  = cn("verificacionCodigo");
    const dispatch = useDispatch();

    const Ref = useRef(null);
    const userinfo      = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const polizaInfo    = JSON.parse(sessionStorage.getItem("infoPoliza"));
    const verifyCode    = useSelector((state) => state.rootReducers.verifyCode);
    const endosoPoliza  = useSelector((state) => state.rootReducers.endosoPoliza);
    const productCatalog    = useSelector((state) => state.rootReducers.productCatalog);
    const refundInformation  = useSelector((state) => state.rootReducers.refundInformation);
    const [timer, setTimer] = useState("00:00");
    const [code, setCode] = useState([...Array(6)].map(() => ""));
    const [mensajeError, setMensajeError] = useState("");
    const [ cargandoProd, setCargandoProd ] = useState(false);

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total,
            minutes,
            seconds,
        };
    };
 
    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            
            setTimer(
                    (minutes > 9
                        ? minutes
                        : "0" + minutes) +
                    ":" +
                    (seconds > 9 ? seconds : "0" + seconds)
            );
        }
    };
 
    const clearTimer = (e) => {
        setTimer("10:00");
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };
 
    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setMinutes( deadline.getMinutes() + 10);
        return deadline;
    };
 
    
    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);
 
    const onClickReset = () => {

        setMensajeError("");

        if( verifyCode.tipoEnvio === '1' ){
            dispatch(postEnviarCorreo({
                "correo": userinfo.correo,
                "nombre": userinfo.nombre,
                "titulo": "Finalización de plazo de póliza"
            })).then( res => { 
                showResult(res);
            });
        } else {
            dispatch(postEnviarSMS({
                "telefono": userinfo.celular,
            })).then( res => { 
                showResult(res);
            });
        }
      
    };

    const showResult = (res) => {
        if( res.payload.datos.codigo === '01' ){
            clearTimer(getDeadTime());
            setCode([...Array(6)].map(() => ""));
        } else {
            setMensajeError(res.payload.datos.descripcion);
        }
    }

    const validarCodigoEnviado = () => {

        setCargandoProd(true);

        var datosArchivo = [
            {
                "contenidoArchivo" : refundInformation.archivoDocCCI,
                "tipoArchivo" : "1",
                "nombreArchivo" : refundInformation.nombreDocCCI
            }
        ]

        var datosPoliza =  {
            "nombre"            : userinfo.nombre,
            "apellidoPaterno"   : userinfo.apepat,
            "apellidoMaterno"   : userinfo.apemat,
            "tipoDocumento"     : userinfo.tipodoc,
            "numeroDocumento"   : userinfo.nrodoc,
            "celular"           : userinfo.celular,
            "correo"            : userinfo.correo,
            "tipoEndoso"        : refundInformation.tipEndoso,
            "codigoBanco"       : refundInformation.codigoBanco,
            "tipoCuentaBanco"   : refundInformation.tipoCuenta,
            "numeroCuenta"      : productCatalog.activarOtros ? null : refundInformation.numeroCuenta,
            "codigoCuentaInterbancario" : productCatalog.activarOtros ?  refundInformation.numeroCuenta : null,
            "montoSolicitud"    : endosoPoliza.datosPoliza.montoEndoso,
            "codigoMonedaSolicitud"     : endosoPoliza.datosPoliza.codigoMoneda,
            "archivos"           : productCatalog.activarOtros ? datosArchivo : [],
            "idPoliza"          : polizaInfo.numpol,
            "idProducto"        : polizaInfo.codprod,
        };

        dispatch(postVerificarCodigo({
            "id": verifyCode.id,
            "otp": code[0] + code[1] + code[2] + code[3] + code[4] + code[5]
        })).then( respu => {
            if( respu.payload.datos.codigo === '01' ){
                dispatch(postRegistrarEndosoPoliza( datosPoliza ))
                    .then( resp => {  

                        if( resp.payload?.datos.numeroSolicitudEndoso === 0 ){
                            mostrarFormularioEdicion(CONTENT_PAG.PAG_ERRO);
                        } else {
                            mostrarPolizaMensaje(LAYOUT_PAG.PAG_EXI);
                        }

                        setCargandoProd(false);

                    } );
                
            } else {
                setMensajeError(respu.payload.datos.descripcion);
                setCargandoProd(false);
            }
        });
    }

    const onFocusInput = (value) => {
        setMensajeError("");
        setCode(value);
    }
 
    return (
        <div className={classes()}>
            <p className={classes('titleConfEdit')}><b>Ingresa el c&oacute;digo de verificaci&oacute;n</b></p>
            <p className={classes('descrConfEdit')}>{descripcionVerificacion}</p>
            <br/><br/>
            <InputVerificationComponent 
                length={6}
                value={code}
                accion={onFocusInput} 
            />
            <br/>
            <div className={classes('detalleConfEdit')}>
                <p>El c&oacute;digo vencer&aacute; en: <br/> <b><span>{timer}</span> min</b></p>
                <p>
                    <a href='#' onClick={ () => onClickReset() }>Generar nuevo c&oacute;digo</a>
                </p>
            </div>
            {
                mensajeError !== "" ?
                    <NotificationComponent faIcon={faTimes} textNotification={mensajeError} tipo="error"/>
                : null
            }
            <div className={classes('btnContinuar')}>
                {
                    cargandoProd ? 
                        <img src={ico_loading} alt='cargando' />  
                    :
                    <ButtonComponent label={'btnContinuar'} nombre={'Continuar'} tipo={'button-red'} action={() => validarCodigoEnviado()} disabled={code[0] === "" || code[1] === "" || code[2] === "" || code[3] === "" || code[4] === "" || code[5] === ""}/>
                }
            </div>
        </div>
    );
};

export default VerificacionCodigo;
